// @flow
import React from "react";
import { Trans, useTranslation } from "react-i18next";

import Soeren from "Commons/Assets/images/Soeren.png";

import Styles from "./Promise.module.scss";

type Props = {
  categoryType: string,
};

const Promise = ({ categoryType }: Props) => {
  const { t } = useTranslation("offerPageDetail");
  const categoryName = categoryType ? t(`categories:${categoryType}`) : "";

  return (
    <div className={Styles.promise}>
      <div className={Styles.widthLimit}>
        <div className={Styles.responsiveContent}>
          <h3>{t("changeServicePromise.title")}</h3>
          <p className={Styles.centerText}>
            &quot;
            <Trans i18nKey="offerPageDetail:changeServicePromise.promise" values={{ categoryName }}>
              <br />
            </Trans>
            &quot;
          </p>
          <div className={Styles.profile}>
            <img src={Soeren} alt="Sören Gruber" />
            <div className={Styles.signature}>
              <h5>{t("hero.contactName")}</h5>
              <h6>{t("hero.contactTitle")}</h6>
            </div>
          </div>
          <div className={Styles.promises}>
            <div className={Styles.column}>
              {t("changeServicePromise.promises", { returnObjects: true })
                .splice(0, 3)
                .map((promise, i) => {
                  return (
                    <React.Fragment key={i}>
                      <h4>{promise.title}</h4>
                      <p>{promise.description}</p>
                    </React.Fragment>
                  );
                })}
            </div>
            <div className={Styles.column}>
              {t("changeServicePromise.promises", { categoryName, returnObjects: true })
                .splice(3)
                .map((promise, i) => {
                  return (
                    <React.Fragment key={i}>
                      <h4>{promise.title}</h4>
                      <p>{promise.description}</p>
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Promise;
